/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { MenuComponent } from '../../../../../../../_metronic/assets/ts/components'
import { ID, KTSVG, QUERIES } from '../../../../../../../_metronic/helpers'
import { useListView } from '../../core/ListViewProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { Automation } from '../../core/_models'

type Props = {
  id: ID
  status: boolean
  automation: Automation
}

const AutomationActionCell: FC<Props> = ({ id, status, automation }) => {
  const userListContext = useListView()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const onStatusShow = (action: boolean) => {
    userListContext.setStatusModal(true, action, automation)
  }

  return (
    <>
      <a
        href='#'
        className='btn btn-light btn-active-light-primary btn-sm'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
        Actions
        <KTSVG path='/media/icons/duotune/arrows/arr072.svg' className='svg-icon-5 m-0' />
      </a>
      {/* begin::Menu */}
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-150px py-4'
        data-kt-menu='true'
      >
        {/* begin::Menu item */}
        <div className='menu-item px-3' onClick={() => userListContext.setItemIdForUpdate(automation._id)}>
          <div className='menu-link px-3'>Edit Scheduler</div>
        </div>

        <div className='menu-item px-3' onClick={() => {
          userListContext.setItemIdForUpdate(automation._id);
          userListContext.setpasswordUpdateCheck(true);
        }}>
          <div className='menu-link px-3'>View Logs</div>
        </div>


        <div className='menu-item px-3' onClick={() => {
          onStatusShow(true);
        }}>
          <div className='menu-link px-3'>Delete</div>
        </div>
        {/* end::Menu item */}
        {/* begin::Menu item */}

      </div>
    </>
  )
}

export { AutomationActionCell }
